import React from 'react';
import { FaCheck } from 'react-icons/fa';

import FarmItems from './FarmItems';
import FormRadio from '../../form/radio';
import Card from './Card';
import Summations from './Summations';
import BankTransfer from './BankTransfer';

const FarmPay = ({ cost, vat, selectedPackage, selectedPayment, choosePaymentMethod }) => {
  return (
    <div>
      <FarmItems
        title="Make your secured payment for your farm."
        subtitle="Choose your payment experience "
      >
        <div className="w-full md:w-3/5 md:pr-2 mb-10 md:mb-0">
          <Card title="How would you like to pay?">
            <div className="flex items-center justify-between">
              <div>
                <FormRadio
                  farm
                  radioValue="creditCard"
                  title="Credit Card"
                  selectedPayment={selectedPayment}
                  click={() => choosePaymentMethod('creditCard')}
                />
              </div>

              <div>
                <FormRadio
                  farm
                  radioValue="transfer"
                  title="Bank Transfer"
                  selectedPayment={selectedPayment}
                  click={() => choosePaymentMethod('transfer')}
                />
              </div>

              <div>
                <FormRadio
                  farm
                  radioValue="wallet"
                  title="Farm Wallet"
                  selectedPayment={selectedPayment}
                  click={() => choosePaymentMethod('wallet')}
                />
              </div>
            </div>

            {selectedPayment === 'creditCard' && (
              <>
                <div className="mt-5 text-center">
                  <p className="text-sm">Easy and fast payment with your card</p>
                  <div className="mt-5 flex flex-row">
                    <div className="mt-1 text-cf-dark">
                      <FaCheck size="15" />
                    </div>
                    <div className="ml-2 text-sm text-left">
                      Stated USD prices are converted to Ghana cedis equivalent at the current
                      exchange rate and payment is processed in cedis.
                    </div>
                  </div>
                  <div className="mt-5 flex flex-row">
                    <div className="mt-1 text-cf-dark">
                      <FaCheck size="15" />
                    </div>
                    <div className="ml-2 text-sm text-left">
                      You will be charged <span className="text-cf-dark">1.95%</span> of the total
                      cost as transaction fee.
                    </div>
                  </div>
                </div>
              </>
            )}

            {selectedPayment === 'transfer' && <BankTransfer />}

            {selectedPayment === 'wallet' && (
              <p className="text-sm my-4">Farm Wallet is currently not available for you</p>
            )}
          </Card>
        </div>

        <div className="w-full md:w-2/5 md:pl-2">
          <Card title="Payment summation" border>
            <Summations cost={cost} vat={vat} packageTitle={selectedPackage.title} />
          </Card>
        </div>
      </FarmItems>
    </div>
  );
};

export default FarmPay;
